import { getWebBookerContext } from './webBookerContext'

export const isWebBookerPath = pathname => /^\/webbookers?(?:\/|$)/i.test(pathname || '')

export const getWebBookerTheme = (companyCode, companyID = 0) => {
  const code = (companyCode || '').trim().toLowerCase()
  // Branding is known from the URL before the company lookup completes.
  if (code === 'de' || code === 'de_passapp' || Number(companyID) === 10010) return 'webbooker-theme-monochrome'
  if (code === 'charchauf' || code === 'charchauf_passapp' || Number(companyID) === 10005) return 'webbooker-theme-gold'
  return 'webbooker-theme-blue'
}

export const getInitialWebBookerTheme = (locationValue = window.location, storage) => {
  const { companyCode } = getWebBookerContext(locationValue)
  let companyID = 0
  // Only an internal dispatch route may use the signed-in company's branding.
  // An external iframe's explicit company must take precedence over storage.
  if (!companyCode && /^\/webbookers(?:\/|$)/i.test(locationValue?.pathname || '')) {
    try {
      companyID = JSON.parse((storage || window.localStorage).getItem('companyID'))
    } catch (error) {
      companyID = 0
    }
  }
  return getWebBookerTheme(companyCode, companyID)
}
